const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const createSolicitud = async (solicitudData) => {
  try {
    const response = await fetch(`${API_URL}/solicitudes/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(solicitudData),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.message || 'Error al crear la solicitud');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en createSolicitud:', error);
    throw error;
  }
};

export const fetchSolicitudes = async (filters = {}) => {
  try {
    const response = await fetch(`${API_URL}/solicitudes/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(filters),
    });

    if (!response.ok) {
      throw new Error('Error al obtener solicitudes');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchSolicitudes:', error);
    throw error;
  }
};

export const fetchSolicitudById = async (id) => {
  try {
    const response = await fetch(`${API_URL}/solicitudes/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al obtener la solicitud');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchSolicitudById:', error);
    throw error;
  }
};

export const updateSolicitud = async (id, updateDto, usuario) => {
  try {
    const response = await fetch(`${API_URL}/solicitudes/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ updateDto, usuario }),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.message || 'Error al actualizar la solicitud');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en updateSolicitud:', error);
    throw error;
  }
};

export const deleteSolicitud = async (id) => {
  try {
    const response = await fetch(`${API_URL}/solicitudes/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al eliminar la solicitud');
    }

    return true;
  } catch (error) {
    console.error('Error en deleteSolicitud:', error);
    throw error;
  }
};

export const addComentario = async (id, comentarioData) => {
  try {
    const response = await fetch(`${API_URL}/solicitudes/${id}/comentarios`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(comentarioData),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.message || 'Error al agregar el comentario');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en addComentario:', error);
    throw error;
  }
};

export const fetchEstadisticas = async () => {
  try {
    const response = await fetch(`${API_URL}/solicitudes/estadisticas/dashboard`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al obtener estadísticas');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchEstadisticas:', error);
    throw error;
  }
};

export const assignUserToSolicitud = async (id, asignadoA, usuario) => {
  try {
    const response = await fetch(`${API_URL}/solicitudes/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 
        updateDto: { asignadoA }, 
        usuario 
      }),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.message || 'Error al asignar usuario');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en assignUserToSolicitud:', error);
    throw error;
  }
};

export const addImageToSolicitud = async (id, imageId, usuario) => {
  try {
    const solicitud = await fetchSolicitudById(id);
    const adjuntos = [...(solicitud.adjuntos || []), imageId];
    
    const response = await fetch(`${API_URL}/solicitudes/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 
        updateDto: { adjuntos }, 
        usuario 
      }),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.message || 'Error al agregar imagen');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en addImageToSolicitud:', error);
    throw error;
  }
};
